import { combineReducers } from 'redux';

import cauHinhHeThong from './CauHinhHeThong/CauHinhHeThong.slice';
import taiKhoan from './TaiKhoan/TaiKhoan.slice';

export default combineReducers({
  taiKhoan,
  cauHinhHeThong,
});
